<template>
  <a
    v-if="isVisible"
    href="#"
    class="btn btn-orange"
    @click.prevent="handleClick">
    Conheça os nossos Planos
  </a>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'PlansCallToAction',
  data () {
    return {
      isUnlimitedPlan: false
    }
  },
  mounted () {
    this.loadAccountPlan()
  },
  methods: {
    loadAccountPlan () {
      loopback
        .get('/accounts')
        .then(account => {
          this.isUnlimitedPlan = account.isUnlimited
        })
        .catch(() => {
          this.isUnlimitedPlan = false
        })
    },
    handleClick (event) {
      this.$emit('click', event)

      $('.modal').modal('hide')
      setTimeout(() => {
        this.$router.push({ name: 'subscription' })
      }, 300)
    }
  },
  computed: {
    isVisible () {
      return !this.isUnlimitedPlan
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-orange {
  background-color: #FF7E39;
  border-color: #FF7E39;
  color: #fff;
  text-decoration: none;
  display: inline-block;

  &:hover, &:focus, &.active {
    background-color: darken(#FF7E39, 5%);
    border-color: darken(#FF7E39, 5%);
    color: #fff !important;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/PlansCallToAction.vue